<template>
    <div v-if="program_id && is_program_loaded">
        test
        <b-modal
            v-model="_show_modal_local"
            :title="program.title"
            class="modal-primary"
            size="lg"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <div class="flex-form">

                <div class="row">

                    <div class="col col-12 col-lg-6">
                        <b-form-group
                            label="Доступность программы"
                        >
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="enabled"
                                    value="1"
                                    v-model="_enabled">
                                <label class="custom-control-label" for="enabled">программа доступна для заказов</label>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col col-12">
                        <b-form-group
                            label="Наименование программы"
                            :invalid-feedback="veeErrors.first('title')"
                            description="Здесь должен быть только текст, не более 200 символов"
                        >
                            <input
                                class="form-control"
                                type="text"
                                v-model="program.title"
                                v-validate="{ required:true,max:200 }"
                                name="title"
                                data-vv-as="'Наименование программы'"
                            >
                        </b-form-group>
                    </div>
                </div>


                <div class="row">
                    <div class="col col-12">
                        <b-form-group
                            label="Подробное описание"
                            :invalid-feedback="veeErrors.first('content_html')"
                            description="Здесь можно использовать HTML-тэги"
                        >
                            <textarea
                                class="form-control"
                                v-model="program.content_html"
                                placeholder="введите несколько строчек"></textarea>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-6  col-lg-4">
                        <b-form-group
                            label="Минимальное количество дней для оформления программы"
                            :invalid-feedback="veeErrors.first('count_day_min')"
                            description="здесь должно быть число, 0 - ограничение не применяется"
                        >
                            <input
                                class="form-control"
                                type="text"
                                v-model.number="program.count_day_min"
                                v-validate="{ required:true,min_value:0,max_value:50  }"
                                name="count_day_min"
                                data-vv-as="'Минимальное количество дней'"
                            >
                        </b-form-group>
                    </div>
                    <div class="col col-6  col-lg-4">
                        <b-form-group
                            label="Максимальное количество дней для оформления программы"
                            :invalid-feedback="veeErrors.first('count_day_max')"
                            description="здесь должен быть целое число, 0 - ограничение не применяется"
                        >
                            <input
                                class="form-control"
                                type="text"
                                v-model.number="program.count_day_max"
                                v-validate="{ required:true,min_value:0,max_value:360  }"
                                name="count_day_max"
                                data-vv-as="'Максимальное количество дней'"
                            >
                        </b-form-group>
                    </div>


                    <div class="col col-6 col-lg-4">
                        <b-form-group
                            label="Индивидуальный % вознаграждения"
                            :invalid-feedback="veeErrors.first('reward_percent')"
                            description="здесь должен быть целое число, 0 - ограничение не применяется"
                        >
                            <input
                                class="form-control"
                                type="text"
                                v-model.number="program.reward_percent"
                                v-validate="{ required:false,min_value:0,max_value:90,decimal:1  }"
                                name="reward_percent"
                                data-vv-as="'Индивидуальный % вознаграждения'"
                            >
                        </b-form-group>
                    </div>

                </div>

                <div class="row">
                    <div class="col col-6  col-lg-4">
                        <b-form-group
                            label="Минимальный возраст"
                            :invalid-feedback="veeErrors.first('age_min')"
                            description="здесь должен быть целое число, 0 - ограничение не применяется"
                        >
                            <input
                                class="form-control"
                                type="text"
                                v-model="program.age_min"
                                v-validate="{ required:true,min_value:0,max_value:80  }"
                                name="age_min"
                                data-vv-as="'Минимальный возраст'"
                            >
                        </b-form-group>
                    </div>
                    <div class="col col-6  col-lg-4">
                        <b-form-group
                            label="Максимальный возраст"
                            :invalid-feedback="veeErrors.first('age_max')"
                            description="здесь должен быть целое число, 0 - ограничение не применяется"
                        >
                            <input
                                class="form-control"
                                type="text"
                                v-model="program.age_max"
                                v-validate="{ required:true,min_value:0,max_value:80  }"
                                name="age_max"
                                data-vv-as="'Максимальный возраст'"
                            >
                        </b-form-group>
                    </div>

                    <div class="col col-6  col-lg-4">
                        <b-form-group
                            label="Пол"
                            description="Если программа ограничена одним полом"
                        >
                            <select class="form-control" v-model.number="program.sex" >
                                <option :value="null">для всех</option>
                                <option :value="1">только для женщин</option>
                                <option :value="2">только для мужчин</option>
                            </select>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-12 col-lg-6">
                        <b-form-group
                            description="совершенно непонятно где и как этот флаг используется"
                        >
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="_nsb_disabled"
                                    value="1"
                                    v-model="_nsb_disabled">
                                <label class="custom-control-label" for="enabled">Отключено на nsb.su</label>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col col-12 col-lg-6">
                        <b-form-group
                            description="совершенно непонятно где и как этот флаг используется"
                        >
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="_select_disabled"
                                    value="1"
                                    v-model="_select_disabled">
                                <label class="custom-control-label" for="enabled">Отключено при подборе тура</label>
                            </div>
                        </b-form-group>
                    </div>
                </div>



                <div class="row" v-if="isExternalBooker(hotel)">
                    <div class="col col-12 col-lg-6">
                        <b-form-group
                            :label="'Программа в системе бронирования #'+booker_program_id"
                            :description="'Объект бронируется через ' + externalBookerName(hotel)"
                        >
                            <v-select
                                :options="booker_tarifs"
                                :plain="true"
                                v-model.number="booker_program_id"
                                label="title"
                                :reduce="x=>x.id"
                                placeholder="Выберите программу"
                            ></v-select>
                        </b-form-group>
                    </div>

                    <div class="col col-12 col-lg-6" v-if="isExternalBooker(hotel) && booker_program_id">
                        <b-form-group
                            :label="'Копирование данных ' + externalBookerName(hotel)"
                            description="будут скопированы наименование, подробное описание, минимальное и максимальное количество дней"
                        >
                            <button type="button" class="btn btn-primary" @click="copyExternProgramData">скопировать данные программы</button>
                        </b-form-group>
                    </div>

                </div>

            </div>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_booker } from '@/functions_booker';
    import { functions_hotel } from '@/functions/hotel';
    import { functions_program } from '@/functions/program.js';


    export default {
        name: 'TarifEditDialog',
        mixins: [functions, functions_booker, functions_hotel, functions_program],
        data: function () {
            return {
            };
        },
        model: {
            prop: "program_id",
            event: "hide"
        },
        props: {
            hotel_prop: Object,
            program_id: Number,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
            handleOk: function () {
                let self = this;
                this.saveProgram(function(self){
                    let hotelProgram = self.findElementByID(self.hotel.programs, self.program.id);
                    console.log('handleOk hotelProgram=',hotelProgram);
                    if (self.is(hotelProgram)) {
                        hotelProgram.title = self.program.title;
                        hotelProgram.prof_obj_tariff_id = self.program.prof_obj_tariff_id;
                    }
                    self.$emit("changed", self.program.id);
                    self.$emit("hide", 0);
                }, self);
            },
            copyExternProgramData: function() {
                let extern_program = this.findElementByID(this.booker_tarifs, this.booker_program_id);
                if (extern_program) {
                    console.log('extern_program', extern_program)
                    this.program.title = extern_program.title;
                    this.program.count_day_min = extern_program.min_days;
                    this.program.count_day_max = extern_program.max_days;
                    this.program.content_html = extern_program.info;
                }
            },
        },
        computed: {
            _show_modal_local: {
                get: function () {
                    return !!this.program_id
                },
                set: function (newValue) {}
            },
            _enabled: {
                get: function () {
                    return !this.program.m_disabled;
                },
                set: function (v) {
                    this.program.m_disabled = !v;
                },
            },
            _nsb_disabled: {
                get: function () {
                    return !!this.program.m_tour_disabled;
                },
                set: function (v) {
                    this.program.m_tour_disabled = !!v;
                },
            },
                _select_disabled: {
                    get: function () {
                        return !!this.program.m_tour_selected_disabled;
                    },
                    set: function (v) {
                        this.program.m_tour_selected_disabled = !!v;
                    },
                },




        },
        created: function() {
            this.hotel = this.hotel_prop;
            this.loadProgram(this.program_id);
            if (this.isExternalBooker(this.hotel)) {
                this.loadBookerPrograms(this.booker_id, this.booker_hotel_id);
            }
        },

    }
</script>
